import PropTypes from 'prop-types';
import React from 'react';
import {
  Paper,
} from '@material-ui/core';

import Cost from 'common/components/Cost';

import styles from './RidePrice.css';

const paperStyle = {
  display: 'inline-block',
  padding: 0,
};

const renderFareInfo = (service, capacity) => {
  if (service.fare_price) {
    const amount = service.fare_price * (capacity || 1);
    return (
      <div key={amount} className={styles.content} data-id="ride-price">
        <Cost amount={amount} currencyCode="USD" />
      </div>
    );
  }
  return <div data-id="ride-price" className={styles.content}>Fare Required</div>;
};

const RidePrice = ({capacity, service}) => {
  if (!service || !service.fare_required) return null;
  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>
        <Paper style={paperStyle}>
          {renderFareInfo(service, capacity)}
        </Paper>
      </div>
    </div>
  );
};

RidePrice.propTypes = {
  capacity: PropTypes.number,
  service: PropTypes.shape({
    fare_price: PropTypes.number,
  }),
};

export default RidePrice;



// WEBPACK FOOTER //
// ./src/ondemand/components/RidePrice/RidePrice.js